import React, { useRef, useEffect, useState } from 'react';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';
import BeatLoader from "react-spinners/BeatLoader";
//import Switch from "react-switch";
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '15%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

Modal.setAppElement('#root')
const AiImageTags = (props) => {
    const [aiData, setAiData] = useState(props.aiData);
    const [cropperRef, setCropperRef] = useState(window.cropperRef);
    const [confidenceCutOff, setConfidenceCutOff] = useState(0.0);
    const [selectedArray, setSelectedArray] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [labelsDetailed, setLabelsDetailed] = useState(<></>);

    let selectedObjectsArray = []


    const [settingsOpen, setSettingsOpen] = useState()


    const [LabelTags, setLabelTags] = useState();


    const [sort1, setSort1] = useState();

    const confidenceSliderChanged = (data) => { setConfidenceCutOff(data / 100) }
    const confidenceSliderFinishedChanging = (data) => {
        setLabelTags(buildLabelTags(data / 100).LabelTags)
        setConfidenceCutOff(data / 100)
    }

    const setSortBy = () => { }
    const sortButton = () => { }
    const gotoSingleLabel = () => { }
    const labelDelete = () => { }



    useEffect(() => {
        console.log({ confidenceCutOff })
        setLabelTags(buildLabelTags(confidenceCutOff).LabelTags)
    }, [confidenceCutOff]
    )

    const openModal = () => {
        setModalIsOpen(true)
    }

    const closeModal = () => {
        setModalIsOpen(false)
    }

    const toggleClass = (className, event) => {
        if (!settingsOpen) {
            event.target.parentNode.classList.add(className)
            setSettingsOpen(true)
        } else {
            event.target.parentNode.classList.remove(className)
            setSettingsOpen(false)
        }
    }

    const buildCrop = () => {
        let x = 9999999999
        let right = 0
        let y = 9999999999
        let bottom = 0


        let boxData = selectedObjectsArray
        boxData.forEach(o => {
            if (o.x < x) {
                x = o.x
            }
            if (o.x + o.width > right) {
                right = o.x + o.width
            }
            if (o.y < y) {
                y = o.y
            }
            if (o.y + o.height > bottom) {
                bottom = o.y + o.height
            }
        })

        let width = right - x
        let height = bottom - y

        let newBox = {
            x: x,
            y: y,
            height: height,
            width: width
        }

        console.log({ newBox })

        if (selectedObjectsArray.length === 0) {
            cropperRef.clear()
        } else {
            cropperRef.crop()
            cropperRef.setData(newBox)
        }
    }



    const labelClicked = (object, e) => {
        let selected = selectedArray
        let controlClicked = e.ctrlKey
        let shiftClicked = e.shiftKey

        let first = object.boundingPoly.normalizedVertices.slice(0, 2)
        let second = object.boundingPoly.normalizedVertices.slice(2, 4)

        let x = (first[0].x * cropperRef.imageData.naturalWidth)
        let y = (first[0].y * cropperRef.imageData.naturalHeight)
        let width = (first[1].x * cropperRef.imageData.naturalWidth) - (first[0].x * cropperRef.imageData.naturalWidth)
        let height = (second[1].y * cropperRef.imageData.naturalHeight) - (first[0].y * cropperRef.imageData.naturalHeight)

        let cropData = { x: x, y: y, width: width, height: height, id: object.id }

        if (controlClicked) {

        } else if (shiftClicked) {
            var index = selected.indexOf(object.id);
            if (index !== -1) {
                selected.splice(index, 1);
                // cropperRef.clear()
                selectedObjectsArray = selectedObjectsArray.filter(obj => obj.id !== object.id)
            } else {
                selected.push(object.id)
                selectedObjectsArray.push(cropData)
            }

        } else {
            selectedObjectsArray = []
            selectedObjectsArray = []
            selected.splice(0, selected.length)
            selected.push(object.id)
            selectedObjectsArray.push(cropData)

        }
        setLabelTags(buildLabelTags(confidenceCutOff).LabelTags)
        buildCrop()
    }

    const buildDetailedTags = () => {
        console.log("building detailed labels")
        // let labelsDetailed = []
        // let labelObjects = []
        // let videoDuration = window.player.getDuration()


        // labelObjects.forEach(object => {
        //     // console.log({ object })
        //     let segments = []
        //     let grids = []




        //     object.segments.forEach((segment, index) => {
        //         let barStart = (segment.startTime / videoDuration) * 100
        //         let barEnd = (segment.endTime / videoDuration) * 100
        //         let barWidth = (barEnd - barStart)

        //         segments.push(
        //             <div className="ems_timeline-tag-marker" onClick={gotoSingleLabel.bind(this, (segment.startTime / videoDuration))} style={{ width: `${barWidth}%`, left: `${barStart}%` }}>
        //             </div>
        //         )

        //         grids.push(

        //             <div className="ems_grid-item">
        //                 <div className="ems_item_label"></div>
        //             </div>,
        //             <div className="ems_grid-item">
        //                 <div className="ems_item_content">
        //                     <div className="ems_text ems_time"></div>
        //                 </div>
        //             </div>,
        //             <div className="ems_grid-item">
        //                 <div className="ems_item_content">
        //                     <div className="ems_text ems_time"></div>
        //                 </div>
        //             </div>,
        //             <div className="ems_grid-item">
        //                 <div className="ems_item_content">
        //                     <div className="ems_text ems_time"> </div>
        //                 </div>
        //             </div>

        //         )
        //     })

        //     labelsDetailed.push(
        //         <div className="ems_group">
        //             <div className="ems_inner">
        //                 <div className="ems_group-item">
        //                     <div className="ems_grid ems_grid-4">
        //                         <div className="ems_grid-item ems_grid-item-c4">
        //                             <div className="ems_item_label">{object.description}</div>
        //                         </div>
        //                         <div className="ems_grid-item ems_grid-item-c4">
        //                             <div className="ems_timeline-wrapper">
        //                                 <div className="ems_timeline-tag">
        //                                     {segments}
        //                                 </div>
        //                             </div>
        //                         </div>
        //                         {grids}
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     )
        // })

        // let returnedData =
        //     <div className="ems_group" style={{ width: "800px" }}>
        //         <div className="ems_inner">
        //             <div className="ems_group-item">
        //                 <div className="ems_description">Here you can take a look at tags in more detail</div>
        //             </div>
        //             <div className="ems_group-item">
        //                 <div className="ems_grid ems_grid-4">
        //                     <div className="ems_grid-item">
        //                         <div className="ems_item_label"></div>
        //                     </div>
        //                     <div className="ems_grid-item">
        //                         <div className="ems_item_label">
        //                             <div className="ems_text">Start time</div>
        //                         </div>
        //                     </div>
        //                     <div className="ems_grid-item">
        //                         <div className="ems_item_label">
        //                             <div className="ems_text">End time</div>
        //                         </div>
        //                     </div>
        //                     <div className="ems_grid-item">
        //                         <div className="ems_item_label">
        //                             <div className="ems_text">Confidence</div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //             {labelsDetailed}



        //         </div>
        //     </div>



        // setLabelsDetailed(returnedData)

        // console.log({ returnedData })







    }



    const buildLabelTags = (confCutOff = 0) => {
        console.log("building label tags")
        let LabelTags = []
        let objectLineData = []

        if (aiData != "nodata" && aiData != "loadingData" && aiData != undefined) {

            aiData[0].localizedObjectAnnotations.forEach(obj => {
                let object = {
                    boundingPoly: obj.boundingPoly,
                    confidence: obj.score,
                    id: `${obj.name}-${obj.score}`
                }
                object.description = obj.name

                const showing = selectedArray.includes(object.id)
                // console.log({ showing, selectedArray, id: object.id })

                let className = showing ? 'ems_tag on_timeline' : 'ems_tag';

                if (selectedArray.includes(object.id)) {
                    className = className + " active"
                }
                objectLineData.push(object)

                // console.log({ obConf: object.confidence, cutOffconf: confidenceCutOff, conoff2: confCutOff })
                if (object.confidence >= confCutOff) {
                    LabelTags.push(
                        <div className={className} confidenceScore={object.confidence} content={object.description} onClick={labelClicked.bind(this, object)}>
                            {object.description}
                        </div>
                    )
                }
            })
        }
        return { LabelTags: LabelTags }



    }

    const updateConfidence = (conf) => {
        setConfidenceCutOff(conf)
    }


    //disables text highlighting when you press shift
    ["keyup", "keydown"].forEach((event) => {
        window.addEventListener(event, (e) => {
            document.onselectstart = function () {
                return !(e.key == "Shift" && e.shiftKey);
            }
        });
    });


    //const [labelObjects, setLabelObjects] = useState(buildLabelTags().labelObjects);
    return (
        <div className="ems_tool_group-content-item">
            <div className="ems_tool_module" toolmodule="imageTags">
                <div className="ems_tool_group-content-item">
                    <div className="ems_item_label">Image Tags</div>
                    <div className="ems_item_content" oncopy="return false">

                        {/* {!LabelTags  &&
                            // <BeatLoader color={"lightgrey"} size={25} />
                        } */}
                        {LabelTags}

                    </div>
                    <div className="ems_tool_group-content-item-toolset" id="ems_inline_toolset-items3">
                        <div className="ems_icon ems_icon_settings" onClick={toggleClass.bind(this, 'is-open')}></div>
                        {/* <div className="ems_icon ems_icon-hasborder ems_icon_settings" onClick={toggleClass.bind(this, 'ems_inline_toolset_items1', 'is-open')}></div> */}
                        <div className="ems_icon ems_icon_more" onClick={openModal.bind(this)}>
                        </div>
                        <div className="ems_tool_group-content-item-toolset-items">

                            <div className="ems_group-item" tooltype="slider">
                                <label className="ems_item_label" for="showTimelineConfidence1">Show confidence (<span className="value">&gt;{(confidenceCutOff * 100).toFixed(0)}</span>)</label>
                                <div className="ems_item_content">
                                    <div className="button-container">
                                        <button className="button-sm" onClick={updateConfidence.bind(this, 0.2)}>Low 20%</button>
                                        <button className="button-sm" onClick={updateConfidence.bind(this, 0.5)}>Medium 50%</button>
                                        <button className="button-sm" onClick={updateConfidence.bind(this, 0.8)}>High 80%</button>
                                    </div>


                                    <div className="ems_slider">


                                        <Slider
                                            onAfterChange={confidenceSliderFinishedChanging.bind(this)}
                                            defaultValue={50}
                                            className="ems_slider-bar"
                                            onChange={confidenceSliderChanged.bind(this)}
                                            confidenceSliderFinishedChanging
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={buildDetailedTags.bind(this)}
                //onRequestClose={this.closeModa()}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <h2>Hello</h2>
                <button onClick={closeModal.bind(this)}>close</button>
                <div>{labelsDetailed}</div>

            </Modal>
        </div>
    );

};

export default AiImageTags;

